export default __webpack_public_path__ + "87f21a2615b34410ecd6b9daf58d6389.png";